<template>
  <div>
    <q-dialog :visible.sync="isVisible" title="预销功能说明" :innerScroll="false" width="900px" :showFooter="false" @close="onCancel">
      <div class="content">
        <h3>一、预销功能说明</h3>
        <p><span>1、</span>有利于各店铺监控相应店铺产品日常走势与日销规划节奏，及时的去发现异常/反馈异常产品，其中重点配置了考核计算标准，可以更好督促店铺去提升月度预销评估的能力，尽可能去匹配公司整个供应链体系，避免过多的资源浪费和无效的产能占用；</p>
        <h3>二、导入说明</h3>
        <p><span>1、首次预估导入</span>：即在当月初对第三个月进行首次预估导入并调整第二个月的预估调整；</p>
        <p><span>&emsp;&ensp;导入位置</span>：在“预销计划”当前页选择月份--商品--批量导入；<el-button type="text" @click="isShowImg(0)">点击查看</el-button></p>
        <p><span>&emsp;&ensp;导入时间</span>：为每月月初；</p>
        <p><span>2、预估调整导入</span>：即在当月月底对第二个月进行最后一次预估调整；</p>
        <p>
          <span>&emsp;&ensp;导入位置</span>：在左侧菜单栏中选择“数据导入”--“预销计划”--“预估调整量导入”，点击页面中“月预估调整导入”；<el-button
            type="text"
            @click="isShowImg(1)"
            >点击查看</el-button
          >
        </p>
        <p><span>&emsp;&ensp;导入时间</span>：为每月15日至月底；</p>
        <p><span>3、季度调整量导入</span>：即在当月月初对当前月的季度预销数据进行调整，每个季度结束后按季度所包含月进行汇总计算；</p>
        <p>
          <span>&emsp;&ensp;导入位置</span>：在左侧菜单栏中选择“数据导入”--“预销计划”--“预估调整量导入”，点击页面中“季度预估调整导入”；<el-button
            type="text"
            @click="isShowImg(2)"
            >点击查看</el-button
          >
        </p>
        <p><span>&emsp;&ensp;导入时间</span>：为每月1日至15日；</p>
        <p><span>4、导入商品限制说明</span>：以下商品均不可导入预销系统；</p>
        <p>&emsp;&ensp;①以ZP或LB或ZX或DZ开头；</p>
        <p>&emsp;&ensp;②一对一小件相关商品；</p>
        <p>&emsp;&ensp;③属于6DZ、6ZP、6ZX、6DK、6LB、6CP、6DY 等产品所关联的商品编码；</p>
        <p>&emsp;&ensp;④属于退市预退市相关商品；</p>
        <h3>三、不考核商品/产品说明</h3>
        <p><span>1、新品不考核说明</span>：上市时间在上月15号及以后的商品/产品不参与考核；</p>
        <p><span>2、其他不考核说明</span>：由商品专员在系统中维护的“不考核商品”；<el-button type="text" @click="$router.push('/leisureProducts')">点击查看</el-button></p>
      </div>
    </q-dialog>
    <el-image
      ref="imgViewRef"
      :src="imgList[0]"
      :preview-src-list="imgList"
      :initial-index="0"
      fit="cover"
      style="display: none"
    ></el-image>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'visible',
    event: 'input',
  },
  props: ['visible', 'skuId', 'spuId'],
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '各店提报数量';
    },
  },
  data() {
    return {
      loading: false,
      imgList: [],
    };
  },
  mounted() {},
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    isShowImg(index) {
      let imgListPath = [
        [require('@/assets/images/tips1.png'), require('@/assets/images/tips2.png')],
        [require('@/assets/images/tips3.png'), require('@/assets/images/tips4.png')],
        [require('@/assets/images/tips3.png'), require('@/assets/images/tips5.png')],
      ];
      this.imgList = imgListPath[index];
      setTimeout((_) => {
        this.$refs.imgViewRef.$el.children[0].click();
      }, 500);
    },
  },
};
</script>

<style lang="stylus" scoped>
.content {
  max-height: 75vh;
  overflow-y: auto;
}
p span {
  font-size: 14px;
  font-weight: 600;
}
>>> .el-dialog {
  margin-top: 50px !important
}
>>> ::-webkit-scrollbar {
  width: 6px;
}

>>> ::-webkit-scrollbar-thumb {
  height: 45.7326%;
  transform: translateY(0%);
  position: relative;
  display: block;
  cursor: pointer;
  border-radius: inherit;
  border-radius: 10px;
  background-color: rgba(144, 147, 153, 0.3);
  transition: 0.3s background-color;
}
</style>
